// extracted by mini-css-extract-plugin
export default {"rightHeaderContainer":"AXfI_","userPersona":"Sp1qn"};